import React from "react";

interface ToastProps {
  type: "success" | "error" | "info";
  children: React.ReactNode;
  detail?: string;
  onDismiss?: () => void;
}

export function Toast({ type, children, detail, onDismiss }: ToastProps) {
  const [showDetail, setShowDetail] = React.useState(false);

  const styles = {
    success: {
      bg: "var(--c-surface)",
      border: "var(--c-border)",
      text: "var(--c-success)",
    },
    error: {
      bg: "var(--c-surface)",
      border: "var(--c-border)",
      text: "var(--c-danger)",
    },
    info: {
      bg: "var(--c-surface)",
      border: "var(--c-border)",
      text: "var(--c-info)",
    },
  }[type];

  return (
    <div
      className="rounded-lg p-4 text-sm"
      style={{
        backgroundColor: styles.bg,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: styles.border,
        color: styles.text,
      }}
    >
      <div className="flex items-start justify-between gap-3">
        <div>{children}</div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="opacity-40 hover:opacity-70 transition-opacity"
            style={{ color: styles.text }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M3 3l8 8M11 3l-8 8" />
            </svg>
          </button>
        )}
      </div>
      {detail && (
        <div className="mt-2">
          <button
            type="button"
            onClick={() => setShowDetail((v) => !v)}
            className="text-xs opacity-60 hover:opacity-90 transition-opacity"
          >
            {showDetail ? "Hide details" : "Show details"}
          </button>
          {showDetail && (
            <pre
              className="mt-2 text-xs rounded-md p-2 overflow-x-auto whitespace-pre-wrap"
              style={{ backgroundColor: "var(--c-surface-2)" }}
            >
              {detail}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}
